import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ProgressBarLayout as ProgressBar } from '@alfa-bank/site-progress-bar/component-desktop';

import type { TProgress, IDeps } from '../models';
import { Progress as Component } from '../form-progress';

import styles from './desktop.css';
import { wrapperStickedClassNameHelperDesktop } from './helpers';

export const FormProgressDesktop = createWidget<IDeps, TProgress>({
    ProgressBar,
    styles,
    wrapperStickedClassNameHelper: wrapperStickedClassNameHelperDesktop,
})(Component);
